/* Step 13 · P6 · lane S13C (owner card "AZEX Step 13 Card V2", P6.1) — EN + AR of the line on the IFRS screen of an engagement that
   keeps the note numbers of its Final report (or of the locked file). No standard paragraph is quoted. */
const I18N_S13_P6_NOTES = {
  en: {
    noteNumbersKept: {
      final: "Note numbers kept as at the Final report of {date}",
      publication: "Note numbers kept as printed in the financial statements published on {date}",
      locked: "Note numbers kept as at the locking of the file on {date}",
    },
  },
  ar: {
    noteNumbersKept: {
      final: "أرقام الإيضاحات محفوظة كما في التقرير النهائي بتاريخ {date}",
      publication: "أرقام الإيضاحات محفوظة كما طُبعت في القوائم المالية المنشورة بتاريخ {date}",
      locked: "أرقام الإيضاحات محفوظة كما في تاريخ قفل الملف {date}",
    },
  },
};

export default I18N_S13_P6_NOTES;
